import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ConversationsService } from "src/app/dashboard/conversations/conversations.service";
import { NewTrackedItemModalComponent } from "src/app/dashboard/conversations/modals/new-tracked-item-modal.component";
import { DashboardService } from "src/app/dashboard/dashboard.service";

import { DashboardModule } from "src/app/dashboard/dashboard.module";
import { LocalStorageService } from "src/app/utils/localstorage.service";

@Component({
    selector: "app-initial-client-task",
    templateUrl: "./initial-client-task.component.html",
    styleUrls: [
        "./initial-client-task.component.css",
        "./../../../../main/accountant/tracked-items-dashboard.component.css",
        "./../../../../../dashboard/files-manager/files-manager.component.scss",
        "./../../../../templates/templates.component.scss",
    ],
    imports: [CommonModule, DashboardModule]
})
export class InitialClientTaskComponent {
  user = this.localStorage.get("user");
  templates = [];
  active_template = {};
  show_templates = false;
  constructor(
    private localStorage: LocalStorageService,
    private conversationsService: ConversationsService,
    private dashboardService: DashboardService,
    private cdr: ChangeDetectorRef,
    private bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.conversationsService.get_tracked_items_default_template().then(
      (res: any) => {
        this.templates = res.tracked_item_templates;
        console.log("THIS TEMPLATES", this.templates);
        console.log("templates", this.templates["tracked_items"]);
        if (this.templates.length > 0) {
          this.selectTemplate(this.templates[0]);
        }
        this.dashboardService.show_loading.next(false);
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        console.log(err);
      }
    );
  }

  async selectTemplate(template) {
    let res = await this.conversationsService.get_tracked_items_template_detail(
      template.uuid
    );
    console.log("response from select template", res);
    this.active_template = res;
    this.cdr.detectChanges();
  }

  openEditModal() {
    this.bsModalRef = this.modalService.show(NewTrackedItemModalComponent, {
      class: "modal-lg",
      initialState: {
        template_edited_uuid: this.active_template["uuid"],
        editMode: true,
        editTemplateMode: true,
        tracked_items: this.active_template["tracked_items"],
      },
    });
    this.cdr.detectChanges();
  }
}
